import getOptimizelyFallbackId from '../../common/getOptimizelyFallbackId';
import getCookie from '../../getCookie';
import getLocale from '../../locale/getLocale';
/**
 * Return default options to be used with all optimizely Fullstack experiments with vanilla sdk. React use a different logic.
 * Attributes like the optOut value ensures that all features/experiments are not enabled when user adds cookie ab_optout=true.
 *
 * @returns {{attributes: {optOut: string, locale: string}, userId: string }}
 */
const getOptimizelyDefaultOptions = () => {
    var _a, _b, _c, _d;
    const locale = getLocale();
    const optOut = (_a = getCookie('ab_optout')) !== null && _a !== void 0 ? _a : '';
    const userId = getOptimizelyFallbackId();
    const qaMode = (_d = (_c = (_b = window.abTest) === null || _b === void 0 ? void 0 : _b.store) === null || _c === void 0 ? void 0 : _c.get('qaMode')) !== null && _d !== void 0 ? _d : false;
    const attributes = {
        locale,
        optOut,
        qaMode,
    };
    return {
        attributes,
        userId,
    };
};
export default getOptimizelyDefaultOptions;
//# sourceMappingURL=getOptimizelyDefaultOptions.js.map